import { TYPEFORM_OPENING_BALANCES_URL_BASE } from "../constants";
import { useUser } from "./useUser";

export function useOpeningBalancesLink() {
    const user = useUser();
    return `${TYPEFORM_OPENING_BALANCES_URL_BASE}#user_id=${user.id}&email=${encodeURIComponent(user.email ?? "")}&name=${encodeURIComponent(user.name ?? "")}`;
}
